import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import './earning.css';
import { useNavigation } from '../../../../shared/utils/useNavigation';
import { CONFIG } from '../../../../shared/constants/common';

const AccountSetupCard = ({
    isVatApplicable,
    isGstApplicable,
    isTaxInfoDisabled,
    isUsUser,
    showTaxInfoRow = true,
    w8FormExpired = false,
    pendingSigningUrl = null
}) => {
    const navigate = useNavigation();
    const [isShow, setIsShow] = useState(true);

    const handleBankAccountClick = () => {
        navigate.toBankAccount();
    };

    const handleTaxClick = () => {
        if (isUsUser) {
            navigate.toW9TaxInfo();
        } else {
            navigate.toW8TaxInfo();
        }
    };

    const handleVatClick = () => {
        navigate.toVatNumber();
    };

    const handleGstClick = () => {
        navigate.toGstNumber();
    };

    return (
        <div className={`g_card ${isShow ? '' : 'card_close'}`}>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">
                    <i className="fa-solid fa-building-columns"></i> Account Setup
                </h3>
                <span onClick={() => setIsShow(!isShow)} className="cm_toggle_card">
                    <FontAwesomeIcon icon={isShow ? faAngleDown : faAngleUp} />
                </span>
            </div>

            {isShow && (
                <>
                    <div className='cm_hr_full'></div>
                    <ul className="payouts_list with_links">
                        <li onClick={handleBankAccountClick}>
                            <div className="d-flex gap-3 align-items-center">
                                <div>
                                    <i className="fa-solid fa-building-columns"></i>
                                </div>
                                <div>
                                    <p><b>Add Banking Details</b></p>
                                    <p>Set up payout method</p>
                                </div>
                            </div>
                            <div className="cm_a_card_s">
                                <i className="fa-solid fa-angle-right"></i>
                            </div>
                        </li>

                        {showTaxInfoRow && (
                            <li
                                onClick={isTaxInfoDisabled ? undefined : handleTaxClick}
                                className={isTaxInfoDisabled ? 'tax-info-disabled' : ''}
                            >
                                <div className="d-flex gap-3 align-items-center">
                                    <div>
                                        <i className="fa-solid fa-file-invoice-dollar"></i>
                                    </div>
                                    <div>
                                        <p><b>Add Tax Information</b></p>
                                        {isUsUser ? (
                                            <p>
                                                Required at ${CONFIG.MIN_BALANCE_TO_TAX_INFO}
                                            </p>
                                        ) : (
                                            <p>
                                                {w8FormExpired
                                                    ? 'W-8BEN form expired — resubmit required'
                                                    : 'Setup your tax information'}
                                            </p>
                                        )}
                                        {!!pendingSigningUrl && !isTaxInfoDisabled && (
                                            <p className="text-warning mb-0">
                                                Complete your tax information
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="cm_a_card_s">
                                    <i className="fa-solid fa-angle-right"></i>
                                </div>
                            </li>
                        )}

                        {isVatApplicable && (
                            <li onClick={handleVatClick}>
                                <div className="d-flex gap-3 align-items-center">
                                    <div>
                                        <i className="fa-solid fa-hashtag"></i>
                                    </div>
                                    <div>
                                        <p><b>VAT Number</b></p>
                                        <p>Submit VAT number</p>
                                    </div>
                                </div>
                                <div className="cm_a_card_s">
                                    <i className="fa-solid fa-angle-right"></i>
                                </div>
                            </li>
                        )}

                        {isGstApplicable && (
                            <li onClick={handleGstClick}>
                                <div className="d-flex gap-3 align-items-center">
                                    <div>
                                        <i className="fa-solid fa-hashtag"></i>
                                    </div>
                                    <div>
                                        <p><b>GST Number</b></p>
                                        <p>Submit GST number</p>
                                    </div>
                                </div>
                                <div className="cm_a_card_s">
                                    <i className="fa-solid fa-angle-right"></i>
                                </div>
                            </li>
                        )}
                    </ul>
                </>
            )}
        </div>
    );
};

export default AccountSetupCard;